module.exports = __webpack_public_path__ + "img/w72b.639d3677.jpg";